import { qs, qsa } from '@/utils/dom';
const CookieConsent = {
    init: () => {
        const cookieConsents = qsa('.cookie-consent');
        if (cookieConsents.length === 0)
            return;
        CookieConsent.loop(cookieConsents);
    },
    loop: (elements) => {
        elements.forEach((element) => {
            CookieConsent.showCookieConsent(element);
            CookieConsent.agreeConsent(element);
        });
    },
    showCookieConsent: (element) => {
        const agreeConsent = localStorage.getItem('agreeConsent');
        if (agreeConsent !== null)
            return;
        const parsedAgreeConsent = JSON.parse(agreeConsent);
        if (parsedAgreeConsent)
            return;
        // if storage not found or the storage is found but return true we run 
        // below code to display the cookie consent
        element.classList.remove('d-none');
    },
    agreeConsent: (element) => {
        const btn = qs('.btn', element);
        btn.addEventListener('click', () => {
            localStorage.setItem('agreeConsent', 'true');
            element.remove();
        });
    }
};
export default CookieConsent;
